import { getCaption } from "@/mixins/Common.js";

export default {
  data() {
    return {
      serverErrors: [],
      submitStatus: null
    };
  },

  methods: {
    onSubmit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitStatus = "PENDING";
        const data = this.createJsonData();

        this.serverRequest({}, data)
          .then(response => {
            if (response.status == 200 && response.data.success == true) {
              if (response.data.payload.toast)
                this.showToast(this.getCaption(response.data.payload.toast), true);

              this.successHandler(response);
            }
            this.submitStatus = "";
          })
          .catch(error => {
            if (error.response.status === 422) {
              if (error.response.data.payload.errors[0].name === "fatal") {
                this.showToast(this.getCaption(error.response.data.payload.errors[0].message), false);
                this.fatalErrorHandler();
              } else {
                this.serverErrors = error.response.data.payload.errors;
                this.$v.$touch();
              }
            }
            this.submitStatus = "";
          });
      }
    },

    getErrorMsg(errorKey) {
      let errors = this.serverErrors.filter(error => error.name === errorKey);
      return errors.map(error => getCaption(error.message));
    },

    hasServerError(errorKey) {
      return (
        this.serverErrors.length > 0 &&
        this.serverErrors.filter(error => error.name === errorKey).length > 0
      );
    },

    onChangeHandler(errorKey, vModel) {
      if (this.hasServerError(errorKey)) {
        this.serverErrors = this.serverErrors.filter(
          error => error.name !== errorKey
        );
        vModel.$touch();
      }
    }
  }
};
